<template>
    <md-dialog :md-fullscreen="false" :md-active="show">
        <div style="position:relative;">
            <md-button @click="close" class="closeX">
                X
            </md-button>
        </div>

        <div class="text-center mt16 ml16 mb16">
            <div class="uppercase" style="padding-right:36px">
                {{ $t('modals.confirmPickup') }}
            </div>
        </div>

        <div class="text-center mt16 ml16 mr16 mb">
            <div v-html="$t('modals.afterCallWithCarrierMessage')" />
        </div>

        <div class="text-center">
            <md-button
                class="card-call-btn bgc-default 4558DE min-width"
                @click="close"
            >
                <div class="uppercase">{{ $t('modals.understand') }}</div>
            </md-button>
        </div>
    </md-dialog>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        close() {
            this.$emit('close');
        }

        // confirm() {
        //     this.$emit('confirm');
        // }
    },

    mounted() {}
};
</script>
<style scoped>
.f85b5a {
    background-color: #f85b5a !important;
    height: 36px;
}

p {
    text-align: left;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: rgba(0, 0, 0, 0.6);
}
</style>
